import axios from "axios";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import {toast} from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { Modal} from 'react-bootstrap';

import Table from 'react-bootstrap/Table';

function Mocks() {
    const navigate = useNavigate()

    const [mock, setMocks] = useState([])
    const [filteredMocks, setFilteredMocks] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    const [showModal, setShowModal] = useState(false);
    const [selectedMock, setSelectedMock] = useState(null);
    const [modalAction, setModalAction] = useState("");

    const user = JSON.parse(localStorage.getItem("user"));
    console.log(user.accessToken);

    useEffect(()=>{
        axios
            .get('https://coda.easylinksmw.com/api/mocks/', {headers : {authorization : "Bearer " + user.accessToken}})
            .then((res)=>{console.log(res);
            setMocks(res.data);
            })
            .catch((err)=>console.log(err))
    }, []);

    // Filter papers by paper name only as user types
    useEffect(() => {
        const results = mock.filter(paperItem =>
            paperItem.name.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredMocks(results);
    }, [searchTerm, mock]);

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };
    
    // const handlePublish = async (id) => {
    //     try {
    //         // 1. Send request to your backend API
    //         // Replace with your actual endpoint URL
    //         await axios.patch(`https://uat.easylinksmw.com/api/mocks/publish/${id}`);

    //         toast.success('Mock publishing successful')

    //         setTimeout(() => {
    //             window.location.reload();
    //         }, 1000); 

    //     } catch (error) {
    //         console.error("Failed to publish mock:", error);
    //         alert("Something went wrong while publishing.");
    //     }
    // };

    const handleConfirmAction = async () => {
        if (!selectedMock) return;

        try {
            // Dynamically choose the correct endpoint endpoint based on the action state
            const endpoint = modalAction === "Publish" ? "publish" : "unpublish";
            await axios.patch(`https://coda.easylinksmw.com/api/mocks/${endpoint}/${selectedMock.id}`);

            toast.success(`Mock exam ${modalAction.toLowerCase()}ed successfully!`);
            setShowModal(false); // Close the modal layout

            // Reload page to refresh state
            setTimeout(() => {
                window.location.reload();
            }, 1000);

        } catch (error) {
            console.error(`Failed to ${modalAction} mock:`, error);
            toast.error(`Something went wrong while trying to ${modalAction.toLowerCase()}.`);
        }
    };

    // const handleUnpublish = async (id) => {
    //     try {
    //         // 1. Send request to your backend API
    //         const response = await axios.patch(`https://uat.easylinksmw.com/api/mocks/unPublish/${id}`);

    //         toast.success('Mock unpublishing successful')

    //         setTimeout(() => {
    //             window.location.reload();
    //         }, 1000); 

    //     } catch (error) {
    //         console.error("Failed to unpublish mock:", error);
    //         alert("Something went wrong while unpublishing.");
    //     }
    // };

    return (
        <div className="paper-listing">
            <div><center><blockquote><b>Mocks Listing</b> </blockquote></center> </div>

            {/* Search Input - Paper Name Only */}
            <div className="mb-3">
                <InputGroup>
                    <InputGroup.Text>🔍</InputGroup.Text>
                    <Form.Control
                        type="text"
                        placeholder="Search by paper name..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                    />
                    {searchTerm && (
                        <button 
                            className="btn btn-outline-secondary" 
                            type="button"
                            onClick={() => setSearchTerm("")}
                        >
                            ✕
                        </button>
                    )}
                </InputGroup>
                {/* <div className="mt-2">
                    <small className="text-muted">
                        Found {filteredPapers.length} result{filteredPapers.length !== 1 ? 's' : ''}
                    </small>
                </div> */}
            </div>

            <Table striped bordered hover variant="light">            
                <thead>
                    <tr>
                    <th>Mock Name</th>
                    <th>Subject</th>
                    <th>Grade Category</th>
                    <th>Grade Level</th>
                    <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                {
                    filteredMocks && filteredMocks.map((mock)=> (
                        
                        <tr key={mock.id}>
                            <td>{mock.name}</td>
                            <td>{mock.subject}</td>
                            <td>{mock.grade_category}</td>
                            <td>{mock.grade_level}</td>
                            <td style={{ display: 'flex', gap: '12px' }}>
                                {/* Update Button (Primary styling) */}
                                <Button as={Link} to={`/addQuestion/${mock.id}`} variant="primary" size="sm">
                                    Add Question
                                </Button>
                                
                                {/* View Button (Secondary or Info styling) */}
                                <Button as={Link} to={`/view/${mock.id}`} variant="outline-secondary" size="sm">
                                    View
                                </Button>
                                {/* Conditional Publish/Unpublish Button */}
                                {mock.is_published === 'Yes' ? (
                                    <Button 
                                        // variant="outline-danger" 
                                        variant="danger" 
                                        size="sm" 
                                        style={{ width: '110px' }} 
                                        onClick={() => {
                                            setSelectedMock(mock);
                                            setModalAction("unPublish");
                                            setShowModal(true);
                                        }}
                                    >
                                        Unpublish
                                    </Button>
                                ) : (
                                    <Button 
                                        variant="success" 
                                        size="sm" 
                                        style={{ width: '110px' }} 
                                        onClick={() => {
                                            setSelectedMock(mock);
                                            setModalAction("Publish");
                                            setShowModal(true);
                                        }}
                                    >
                                        Publish
                                    </Button>
                                )}
                            </td>
                        </tr>                    
                    ))
                }
                </tbody>
            </Table>
            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{modalAction} Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to <strong>{modalAction.toLowerCase()}</strong> the mock exam 
                    <strong> "{selectedMock?.name}"</strong>? 
                    {modalAction === "Unpublish" && " This will make it hidden from students."}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cancel
                    </Button>
                    <Button 
                        variant={modalAction === "Publish" ? "success" : "danger"} 
                        onClick={handleConfirmAction}
                    >
                        Confirm {modalAction}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default Mocks;